module.exports = __webpack_public_path__ + "img/icoBibSVE.cc454d2c.png";